// /* eslint-disable */
// import React, { useEffect, useState } from 'react';
// import { useTranslation } from 'react-i18next';
// import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
// import { Button, List } from 'antd';
// import { useNavigate } from 'react-router-dom';
// import * as Auth from '@app/components/layouts/AuthLayout/AuthLayout.styles';
// import { useSelector } from 'react-redux';
// import { RootState } from '@app/store/store';
// import { Loading } from '@app/components/common/Loading/Loading';
// const PrinciplePage: React.FC = () => {
//   const { t } = useTranslation();
//   const navigate = useNavigate();
//   const voucher = useSelector((state: RootState) => state.voucherSlice.voucher);
//   const [isLoading,setIsLoading]= useState<boolean>(true);
//   const data = [
//     t('1. Voucher chỉ kích hoạt 01 (một) lần duy nhất, không được bổ sung thêm thành viên sau khi hoàn thành Đăng ký.'),
//     t('2. Voucher chỉ có thể chuyển nhượng trước khi kích hoạt.'),
//     t('3. Quý khách vui lòng điền đầy đủ và chính xác SĐT/ email và CCCD của từng thành viên để Vinmec gửi thông tin xác nhận Đăng ký và xác định danh tính trong quá trình sử dụng dịch vụ.'),
//     t('4. Nếu thành viên là trẻ em chưa có Số định danh cá nhân/ Số CCCD và SĐT/ email vui lòng đăng ký theo số CCCD của bố/mẹ và SĐT/email của bố/mẹ.'),
//     t(`5. Voucher của quý khách được hưởng tối đa `)+ voucher?.LimitUser + t(' lần sử dụng gói SKTQ tiêu chuẩn tương ứng với tối đa ')+ voucher?.LimitUser +  t(' thành viên.'),
//     t('Lưu ý')+":",
//     t('- 1 thành viên có thể sử dụng nhiều hơn 1 gói SKTQ tiêu chuẩn (Quý khách cần nhập thông tin thành viên 2 lần nếu muốn sử dụng 2 lần gói SKTQ).'),
//     t('- Hiện nay trẻ em khi đăng ký khai sinh đã có số định danh cá nhân trên Giấy khai sinh. Khi trẻ sử dụng dịch vụ thì bố/ mẹ cần mang theo loại giấy tờ đã đăng ký để định danh Thành viên.')
//   ];
//   const navigateToFormPage = () => {
//     {
//       navigate(`../persons`);
//     }
//   };
//   useEffect(()=>{if(voucher){
//     setIsLoading(false);
//   }
// else{
//   navigate('../')
// }},[])
//   if(isLoading) return <Loading/>
//   return (
//     <>
//       <div className="OutSide">
//       <Auth.FormWrapper >
//         <Auth.FormTitle>{t('NGUYÊN TẮC ĐĂNG KÝ THÀNH VIÊN')}</Auth.FormTitle>
//         <Auth.LoginDescription style={{ backgroundColor: 'white', padding: '10px' ,marginBottom:'5px'}}>
//           <List dataSource={data} renderItem={(item) => <List.Item className="principle">{item}</List.Item>} />
//         </Auth.LoginDescription>
//         <div style={{ justifyContent: 'center', display: 'flex' }}>
//           <Button type="primary" onClick={navigateToFormPage} style={{ alignItems: 'center' }}>
//             {t('Tiếp tục')}
//           </Button>
//         </div>
//       </Auth.FormWrapper>
//       </div>
//     </>
//   );
// };

// export default PrinciplePage;
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import PackageForm from '@app/components/package/PackageForm';

const PackagePage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageTitle>{t('Gói dịch vụ')}</PageTitle>
      <PackageForm />
    </>
  );
};

export default PackagePage;
